import type Sale from '@common/Sale';
import charPassImg from '@assets/mint/character_pass_placeholder.gif';
import { extendSales } from '@common/SaleUtils';
import prod from './saleData.prod.json';

export const prodSales: Sale[] = prod as Sale[];

const prodSaleOverrides: Partial<Sale>[] = [
  {
    saleId: 'BAYC',
    pfpPlaceholderUrl: charPassImg,
  },
  {
    saleId: 'MAYC',
    pfpPlaceholderUrl: charPassImg,
  },
];

export const sales = extendSales(prodSales, prodSaleOverrides);

export default sales;
